import React, {FC, useState} from "react";
import twFocusClass from "utils/twFocusClass";
import NcDropDown from "components/NcDropDown/NcDropDown";
import ModalReportItem from "components/ModalReportItem/ModalReportItem";
import {PostDataType} from "data/types";
import ModalHideAuthor from "./ModalHideAuthor";
import {useHistory} from "react-router";
import ModalEditPost from "../ModalEditPost/ModalEditPost";
import {auth} from "../../configs/firebase-config";
import {SINGLE} from "../../data/single";

export interface PostActionDropdownProps {
  containerClassName?: string;
  iconClass?: string;
  postData: PostDataType;
  dropdownPositon?: "up" | "down";
  data: any
}

const PostActionDropdown: FC<PostActionDropdownProps> = ({
                                                           containerClassName = "h-8 w-8 bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700",
                                                           iconClass = "h-[18px] w-[18px]",
                                                           dropdownPositon = "down",
                                                           postData,
                                                           data
                                                         }) => {

  let actions = auth.currentUser?.uid === postData.author.id
    ? [
      {
        id: "EditPost",
        name: "Edit Post",
        icon: "las la-edit",
      },
      {
        id: "copylink",
        name: "Share link",
        icon: "las la-copy",
      },
      {
        id: "commentThisArticle",
        name: "Comment Section",
        icon: "las la-comment-dots",
      },
      {
        id: "reportThisArticle",
        name: "Report this article",
        icon: "las la-flag",
      },
    ] :
    [
      {
        id: "copylink",
        name: "Share link",
        icon: "las la-copy",
      },
      {
        id: "commentThisArticle",
        name: "Comment Section",
        icon: "las la-comment-dots",
      },
      {
        id: "hideThisAuthor",
        name: "Less from this author",
        icon: "las la-user-slash",
      },
      {
        id: "reportThisArticle",
        name: "Report this article",
        icon: "las la-flag",
      },
    ];

  let history = useHistory();

  const [isReporting, setIsReporting] = useState(false);
  const [showModalHideAuthor, setShowModalHideAuthor] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isEditPost, setIsEditPost] = useState(false);

  const openModalReportPost = () => setIsReporting(true);
  const closeModalReportPost = () => setIsReporting(false);

  const openModalHideAuthor = () => setShowModalHideAuthor(true);
  const onCloseModalHideAuthor = () => setShowModalHideAuthor(false);

  const openModalEditPost= () => setIsEditPost(true);
  const closeModalEditPost = () => setIsEditPost(false);

  const hanldeClickDropDown = (item: typeof actions[number]) => {
    if (item.id === "copylink") {
      navigator.clipboard.writeText(window.location.origin + postData.href);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
      return;
    }
    if (item.id === "reportThisArticle") {
      return openModalReportPost();
    }
    if (item.id === "hideThisAuthor") {
      return openModalHideAuthor();
    }
    if (item.id === "commentThisArticle") {
      return history.push(postData.href + "#comment");
    }
    if (item.id === "EditPost") {
      return  openModalEditPost();
    }

    return;
  };

  const renderMenu = () => {
    if (isCopied) {
      actions = actions.map((item) => {
        if (item.id !== "copylink") return item;
        return {
          ...item,
          name: "Link Copied",
        };
      });
    }
    return (
      <NcDropDown
        className={`text-neutral-500 dark:text-neutral-400 flex items-center justify-center rounded-full  ${containerClassName} ${twFocusClass()}`}
        iconClass={iconClass}
        data={actions}
        panelMenusClass={
          dropdownPositon === "up" ? "origin-bottom-right bottom-0" : undefined
        }
        onClick={hanldeClickDropDown}
      />
    );
  };

  return (
    <div>
      {renderMenu()}

      <ModalReportItem
        show={isReporting}
        id={postData.id}
        onCloseModalReportItem={closeModalReportPost}
      />
      <ModalHideAuthor
        show={showModalHideAuthor}
        author={postData.author}
        onCloseModalHideAuthor={onCloseModalHideAuthor}
      />
      {data !== SINGLE ?
        <ModalEditPost
          show={isEditPost}
          onCloseModalEditPost={closeModalEditPost}
          data={data}
        />
        :
        <></>
      }

    </div>
  );
};

export default PostActionDropdown;
